import { footerData, siteInfo, navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200/50 border-t border-background-300/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm font-heading">
                51
              </div>
              <span className="font-heading font-bold text-foreground-950 text-base whitespace-nowrap">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">{footerData.intro}</p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-300 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-links-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">{section.title}</h4>
              {section.isPartner ? (
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1.5 rounded-md bg-background-300/50 text-xs text-foreground-400">虚位以待</span>
                  <span className="px-3 py-1.5 rounded-md bg-background-300/50 text-xs text-foreground-400">诚邀合作</span>
                </div>
              ) : (
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2019-2024 {siteInfo.name} · 吃瓜爆料第一站 · 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            {navLinks.slice(0, 4).map((link) => (
              <a key={link.href} href={link.href} className="text-xs text-foreground-400 hover:text-primary-600 transition-colors">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}